(function () {
    'use strict';

    a3_pilot_reports.factory('FlightCheckInsFactory', FlightCheckInsFactory);

    /**
     * @memberof PilotReports
     * @ngdoc factory
     * @name FlightCheckInsFactory
     * @ngInject
     */
    function FlightCheckInsFactory(GenericService) {
        function FlightCheckIn() {
			this.FlightId = null;
            this.CrewId = null;
            this.CheckIn = null;
            this.WillBeThereAt = null;

		}

        var objType ='flightCheckIns';
		var objCallback = FlightCheckIn; 

        var service = {
            updateFlightCrewCheckInToStorage : updateFlightCrewCheckInToStorage,
            getFlightCrewCheckInFromStorage : getFlightCrewCheckInFromStorage,
            cleanOldData: cleanOldData
        };

         /**
         * Get Crew Check-Ins.
         * @memberof CrewCallFactory
         * @returns {Array} CrewPhoneNumbers 
         */
		function getCrewCheckInFromStorage() {
			return GenericService.list(objType,objCallback);
		}

        /**
         * Save crew checkIns to storage
         * @memberof CrewCallFactory
         * @param {Array} CrewPhoneNumbers
         */
		function setCrewCheckInToStorage(objList) {
			GenericService.saveAll(objList,objType);
        }

        /**
         * Update Crew CheckIns for specified flight
         * @memberof CrewCallFactory
         * @param {} flight duty
         * @returns {Array} CrewFlightCrewCheckIns 
         */
        function updateFlightCrewCheckInToStorage(duty){
            //Get all checkIns exept current flight from storage
            var storedCheckIns = getCrewCheckInFromStorage();
            var storedCheckInsFiltered = storedCheckIns.filter(f=>f.FlightId != duty.FlightInfo.FlightId);
            //Get checkIns from duty and add new crew checkIns to list
            if(duty && duty.FlightInfo && duty.FlightInfo.crew){
                duty.FlightInfo.crew.forEach(function(item){
                    storedCheckInsFiltered.push({FlightId:  duty.FlightInfo.FlightId, CrewId: item.id, CheckIn: item.CheckIn, WillBeThereAt: item.WillBeThereAt});
                });
                //save checkIns
                setCrewCheckInToStorage(storedCheckInsFiltered);
            }
        }

        /**
         * Get Crew CheckIns for specified flight
         * @memberof CrewCallFactory
         * @param {number} flightId
         * @returns {Array} CrewFlightCrewCheckIns 
         */
		function getFlightCrewCheckInFromStorage(flightId) {
			var storedCheckIns = getCrewCheckInFromStorage();
            return storedCheckIns.filter(x => x.FlightId == flightId);
		}


         /**
         * Clean ls from old flights crew check-ins
         * @param {array} flights Synced flights
         */
          function cleanOldData(responseFlightIds){
            var storedCheckIns = getCrewCheckInFromStorage();
            //Filter out crew check-ins of old flights
            var previousCheckIns = storedCheckIns.filter(x => responseFlightIds.includes(x.FlightId));
            
            setCrewCheckInToStorage(previousCheckIns);
        }

        return service;
    }
})();